import { render, staticRenderFns } from "./xlibro.vue?vue&type=template&id=505d5cc8&scoped=true"
import script from "./xlibro.vue?vue&type=script&lang=js"
export * from "./xlibro.vue?vue&type=script&lang=js"
import style0 from "./xlibro.vue?vue&type=style&index=0&id=505d5cc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505d5cc8",
  null
  
)

export default component.exports